import { Stack, Typography, styled } from '@mui/material';

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexFlow: 'row',
  alignItems: 'center',
  justifyContent: 'space-around',
  cursor: 'pointer',
  width: '430px',
  height: 'auto',
  padding: theme.spacing(1.5),
  borderRadius: '8px',
  ...theme.mixins.defaultTransition,
  '&:hover': {
    background: '#F2F4F8',
  },
  [theme.breakpoints.down('lg')]: {
    width: '400px',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    maxWidth: '480px',
    justifyContent: 'flex-start',
    padding: 0,
  },
}));
export const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.colorGrey?.primary,
}));
export const StyledHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.colorBrand?.primary,
}));
export const StyledImage = styled(`img`)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));
export const StyledTextWrapper = styled(Stack)(({ theme }) => ({
  ...theme.mixins.flexColumnStartStart,
  margin: theme.spacing(0.25, 0, 0, 0.5),
}));
